// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T16:59:49.705Z
// Property: Strawberry Lane (ID: 6767906449167261)
// Collections: 13 amenities, 3 floorplans (live), 16 photos, 77 POIs, 1 reviews, 3 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167261",
  "property_external_id": "1101865",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/strawberry-lane/5YJVMb/",
  "property_apartments_url": "https://www.apartments.com/strawberry-lane-anchorage-ak/y7lvr8s/",
  "property_google_business_url": "https://www.google.com/maps/place/Strawberry+Lane/data=!4m2!3m1!1s0x0:0xd8bdd00f426a4eb4?sa=X&ved=2ahUKEwit9_2WmoSTAxXeSjABHUEJKVgQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47606453394",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "strawberry-lane",
  "property_name": "Strawberry Lane",
  "property_website_url": "https://www.strawberrylaneapartments.com/",
  "property_domain": "https://www.strawberrylaneapartments.com/",
  "property_address": "2001 W 80th Ave",
  "property_full_address": "2001 W 80th Ave, Anchorage, AK 99502",
  "property_address_1": "2001 W 80th Ave",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99502",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Sand Lake",
  "property_address_latitude": "61.1495768",
  "property_address_longitude": "-149.9174125",
  "property_email": "strawberrylane@weidner.com",
  "property_phone": "(907) 308-5523",
  "property_call_tracking_phone": "907-308-5523",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Strawberry Lane in Anchorage, AK, where comfort meets style. Enjoy bright two-bedroom apartments with private patios, lush courtyards, and free assigned parking. With pet stations, a courtesy patrol, and flexible lease terms, you'll find everything you need. Find your new home today—schedule a tour or browse our availability!",
  "property_long_description": "Welcome to Strawberry Lane, where comfort meets community in the heart of Anchorage, AK. Our thoughtfully designed two-bedroom apartments provide the perfect blend of modern living and serene surroundings, featuring lush courtyards that invite you to unwind and enjoy the fresh Alaskan air.\n\nAt Strawberry Lane, we believe in making your life easier. Each apartment is equipped with a dishwasher for effortless clean-up, and you’ll appreciate the convenience of your own private patio or balcony—ideal for sipping coffee while soaking in the stunning views. Our assigned parking space is not just free; it's a hassle-free way to come home.\n\nYour furry friends are welcome here! Our pet stations ensure that every member of your family feels at home and enjoys their time in our community. For your peace of mind, we offer flexible lease terms and a dedicated courtesy patrol service, letting you focus on what really matters—living your best life.\n\nFor those in need of extra space, additional storage units are available to keep your home organized and clutter-free.\n\nDiscover the vibrant lifestyle that awaits you at Strawberry Lane. Finding your new home has never been easier! Browse our availability online or schedule a tour today to experience firsthand the welcoming spirit of our community. Your perfect Anchorage apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-8154-77d2-b42c-a945a52cc947.webp",
  "property_featured_image_media": {
    "alt_text": "Strawberry Lane Apartment Homes monument sign",
    "public_id": "01a07555-8154-77d2-b42c-a945a52cc947",
    "storage_key": "property/6767906449167261/01a07555-8154-77d2-b42c-a945a52cc947.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "184",
  "property_year_built": "2004",
  "property_year_renovated": null,
  "property_walk_score": "16",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.73913043478261",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://strawberrylaneapartments.securecafe.com/onlineleasing/strawberry-lane-0/floorplans.aspx",
  "property_resident_portal_url": "https://strawberrylaneapartments.securecafenet.com/residentservices/strawberry-lane-0/userlogin",
  "property_apply_now_url": "https://strawberrylaneapartments.securecafe.com/onlineleasing/strawberry-lane-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f8160-543f-746b-99be-67e5256d5f22.webp",
  "property_primary_logo_media": {
    "alt_text": "Strawberry Lane Apartment Homes logo",
    "public_id": "019f8160-543f-746b-99be-67e5256d5f22",
    "storage_key": "property/6767906449167261/019f8160-543f-746b-99be-67e5256d5f22.webp",
    "width": 163,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f815a-8e9e-755b-9a6c-9b271830b121.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Strawberry Lane Apartment Homes logo.",
    "public_id": "019f815a-8e9e-755b-9a6c-9b271830b121",
    "storage_key": "property/6767906449167261/019f815a-8e9e-755b-9a6c-9b271830b121.webp",
    "width": 2364,
    "height": 1086
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f8160-543f-746b-99be-67e5256d5f22.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Strawberry Lane Apartment Homes logo",
    "public_id": "019f8160-543f-746b-99be-67e5256d5f22",
    "storage_key": "property/6767906449167261/019f8160-543f-746b-99be-67e5256d5f22.webp",
    "width": 163,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#7A2E2E",
  "property_secondary_color": "#4E1D1F",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#C9A79E",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "680 - 780",
  "property_sqft_min": "680",
  "property_sqft_max": "780",
  "property_price_range": "1635 - 1650",
  "property_price_min": "1635",
  "property_price_max": "1650",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/StrawberryLaneApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/strawberrylaneapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJtRvsZjuYyFYRtE5qQg_Qvdg",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Strawberry Lane",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Strawberry Lane in Anchorage, AK, where comfort meets convenience. Enjoy our lush courtyards, pet-friendly spaces, and assigned parking—all at no cost. Each apartment features a dishwasher, private patio, and flexible lease terms, ensuring a perfect fit for your lifestyle. Make Strawberry Lane your home today!",
  "property_home_floorplans_blurb": "At Strawberry Lane in Anchorage, AK, your ideal apartment home awaits! With a variety of thoughtfully designed floor plans, each space is crafted for comfort and style. Unwind in a vibrant community surrounded by stunning Alaskan landscapes. Browse our available options and envision your new lifestyle today!",
  "property_home_gallery_blurb": "Welcome to Strawberry Lane, your sanctuary in Anchorage, AK! Embrace a lifestyle of comfort with lush courtyards, assigned parking, and pet-friendly amenities. Enjoy leisurely mornings on your private patio or balcony, and experience flexible lease terms that fit your needs. Picture yourself living here and thriving every day!",
  "property_home_neighborhood_blurb": "At Strawberry Lane in Anchorage, AK, experience a vibrant lifestyle surrounded by nature and culture. Enjoy nearby gems like the Alaska Zoo, Anchorage Museum, and Kincaid Park. Connect with knowledge at the Z.J. Loussac Library or explore the beauty of Potter Marsh. Adventure awaits right outside your door!",
  "property_home_reviews_blurb": "At Strawberry Lane in Anchorage, AK, residents rave about the vibrant community atmosphere, stating, \"I love the friendly neighbors and beautiful surroundings!\" Experience a living environment where comfort meets connection. See what our residents have to say about living at our community and join the Strawberry Lane family today!",
  "property_neighborhood_blurb": "Nestled in the heart of Anchorage, Strawberry Lane is surrounded by vibrant cultural gems and scenic parks. Enjoy serene strolls at Kincaid Park, discover history at the Anchorage Museum, or unwind at nearby Alaska Botanical Garden. Experience the great outdoors and urban adventures, all just moments from your new home.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Strawberry Lane in Anchorage, AK, experience life amidst lush courtyards and unwind on your private patio or balcony. With free assigned parking, pet stations, and flexible lease terms, our two-bedroom apartments offer comfort and convenience. Enjoy additional storage and even a dishwasher to elevate your lifestyle!",
  "property_applynow_blurb": "Nestled in the heart of Anchorage, Strawberry Lane offers spacious two-bedroom floor plans with inviting private patios. Enjoy lush courtyards, assigned parking, and convenient pet stations. With flexible lease terms and added storage, your ideal home awaits. Find your new sanctuary and lease online today!",
  "property_contactus_blurb": "At Strawberry Lane in Anchorage, AK, our thoughtfully designed two-bedroom apartments offer the perfect blend of comfort and style. With stunning views and spacious layouts, you'll find your ideal retreat. Have questions? Contact our leasing team today to learn more about calling Strawberry Lane home!",
  "property_faqs_blurb": "At Strawberry Lane in Anchorage, AK, our spacious two-bedroom apartments offer comfort and convenience tailored to your lifestyle. Curious about our community? Dive into our FAQs page for insights on amenities, leasing, and more to help you make Strawberry Lane your next home sweet home.",
  "property_floorplans_blurb": "At Strawberry Lane in Anchorage, AK, our thoughtfully designed two-bedroom floor plans create a cozy retreat to call home. Enjoy spacious layouts and modern amenities that complement your lifestyle. Browse our available apartment homes today and choose the perfect setting for your next adventure in comfort and style.",
  "property_gallery_blurb": "At Strawberry Lane in Anchorage, AK, imagine unwinding on your private balcony while surrounded by lush courtyards. Our spacious two-bedroom apartments offer modern amenities, including dishwashers and additional storage. Enjoy free assigned parking and pet-friendly features, all with flexible lease terms. Picture yourself living here!",
  "property_interactivemap_blurb": "At Strawberry Lane in Anchorage, AK, find your perfect retreat with spacious two-bedroom apartments overlooking lush courtyards. Enjoy convenient amenities like assigned parking, private patios, and pet stations among a vibrant community. Use our interactive map to uncover your next home—your ideal lifestyle awaits!",
  "property_pets_blurb": "At Strawberry Lane in Anchorage, AK, your furry friends are part of the family! Bring up to two pets, from playful pups to charming reptiles, and enjoy a community that embraces your lifestyle. With no weight limits and flexible guidelines, it’s the perfect home for every pet enthusiast.",
  "property_referafriend_blurb": "At Strawberry Lane in Anchorage, AK, our spacious two-bedroom apartments are designed for living vibrantly. Invite a friend to join our welcoming community—because great friends make great neighbors! Refer a friend today and share the joy of life at Strawberry Lane! Your new adventure awaits.",
  "property_residentaccess_blurb": "Welcome to Strawberry Lane in Anchorage, AK, where our spacious two-bedroom floor plans are designed for your comfort. Log in to your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with the vibrant community around you. Your convenience is just a click away!",
  "property_reviews_blurb": "At Strawberry Lane in Anchorage, AK, residents rave about the “welcoming atmosphere and attentive management.” This vibrant community offers more than just a home; it fosters connections and comfort. Want to know more? See what our residents have to say about living at our community! ",
  "property_created_at": "1771544123243",
  "property_scheduletour_blurb": "At Strawberry Lane in Anchorage, AK, our thoughtfully designed two-bedroom floor plans offer the perfect blend of comfort and style. Schedule a tour to experience the vibrant community life firsthand, and hear why our residents love calling Strawberry Lane home. Your ideal living space awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Strawberry Lane in beautiful Anchorage, AK! We’re excited to connect with you about our spacious two-bedroom floor plans. Your inquiry is important to us, and a team member will be in touch soon to help you find your perfect home!",
  "property_virtualtours_blurb": "At Strawberry Lane in Anchorage, AK, our spacious two-bedroom apartments redefine comfort. Immerse yourself in a virtual tour of our beautiful community and experience the inviting atmosphere and stunning layouts that await you. Your ideal home is just a click away—step inside today and envision your future!",
  "property_copyright": "2026 All Rights Reserved. Strawberry Lane",
  "property_seo_title_home": "Spacious apartments for rent - Strawberry Lane - Anchorage, AK",
  "property_seo_description_home": "Comfortable living awaits at Strawberry Lane. Tour pet-friendly apartments with storage and a central Anchorage, AK location.",
  "property_seo_title_floorplans": "Two bedroom floor plans - Strawberry Lane - Anchorage, AK",
  "property_seo_description_floorplans": "Discover spacious two bedroom floor plans with large closets, gas stoves, and private patios at Strawberry Lane in Anchorage, AK.",
  "property_seo_title_amenities": "Amenities for comfort - Strawberry Lane Apartments - Anchorage, AK",
  "property_seo_description_amenities": "Enjoy pet-friendly living with private patio, storage, assigned parking, and in-home dishwasher at Strawberry Lane in Anchorage, AK.",
  "property_seo_title_gallery": "Apartment gallery - Strawberry Lane - Anchorage, AK",
  "property_seo_description_gallery": "Browse Strawberry Lane's Anchorage, AK photo gallery - see modern two-bedroom apartments, kitchens, community spaces, and green areas.",
  "property_seo_title_virtualtours": "Strawberry Lane virtual tour - Anchorage, AK apartments",
  "property_seo_description_virtualtours": "Experience Strawberry Lane from your screen. Explore apartments in Anchorage, AK, virtually and see what life could look like from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Strawberry Lane Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Strawberry Lane in Anchorage, AK! Use our interactive map to explore lush courtyards, pet-friendly amenities, and more!",
  "property_seo_title_neighborhood": "Strawberry Lane neighborhood guide - Anchorage, AK",
  "property_seo_description_neighborhood": "Explore Strawberry Lane's location in south Anchorage, AK - near Dimond Mall, Costco, and Pamela Joy Lowry Memorial Park.",
  "property_seo_title_contact": "Contact Strawberry Lane Apartments - Anchorage, AK",
  "property_seo_description_contact": "Have a question or want to learn more? Contact Strawberry Lane in Anchorage, AK. Our leasing team is ready to assist your apartment search.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Join us at Strawberry Lane in Anchorage, AK! Enjoy spacious two-bedroom floor plans, lush courtyards, and pet-friendly amenities. Get your FAQs answered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Experience life at Strawberry Lane in Anchorage, AK! Read resident reviews on our vibrant pet-friendly community with lush courtyards and modern amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Find your perfect home at Strawberry Lane in Anchorage, AK! Enjoy spacious two-bedroom layouts, lush courtyards, and pet-friendly amenities. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Strawberry Lane",
  "property_seo_description_residentaccess": "Access your Strawberry Lane resident portal in Anchorage, AK! Manage payments, request maintenance, and enjoy a seamless living experience all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Strawberry Lane",
  "property_seo_description_referafriend": "Refer a friend to Strawberry Lane in Anchorage, AK! Great friends create great neighbors—share the joy of living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a tour - Strawberry Lane - Anchorage, AK",
  "property_seo_description_scheduletour": "Book a personal or virtual tour of Strawberry Lane apartments in Anchorage, AK. Explore two-bedroom layouts and on-site perks.",
  "property_seo_title_privacy": "Privacy Policy | Strawberry Lane",
  "property_seo_description_privacy": "Protecting your peace of mind at Strawberry Lane, Anchorage. Read our privacy policy to learn how we safeguard your information securely and transparently.",
  "property_seo_title_accessibility": "Website Accessibility | Strawberry Lane",
  "property_seo_description_accessibility": "At Strawberry Lane in Anchorage, AK, we prioritize digital inclusion. Explore our commitment to accessible living and community for all. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Strawberry Lane",
  "property_seo_description_sitemap": "Navigate Strawberry Lane in Anchorage, AK, with ease! Check out our sitemap for a comprehensive guide to your future home and all we have to offer.",
  "property_seo_title_thankyou": "Thank You | Strawberry Lane",
  "property_seo_description_thankyou": "Thank you for reaching out to Strawberry Lane! Our team will be in touch soon to help you find your ideal Anchorage home. Stay tuned for your next adventure!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293659098",
  "amenities": [
    {
      "id": "ec_d3938b60c1b093e335596519",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452523",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6d8332af304e4fedd60f211",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452525",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_288518ab317674ea2ca75fa1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452526",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45802fd2bb58fb61dbf6f056",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "120692088",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc29100e774841bcc425a92e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452524",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb60a1eb7e6be27ece3d9df8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452527",
      "title": "Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79ae38ecc4b87bdd14deb7b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "120692090",
      "title": "Assigned Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e48b76b6278b24e429269468",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "120692091",
      "title": "Breakfast Bars",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87a822739356fa7dd7e1b17d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "124799801",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a4ebfbf1c9cf2a8680ed23b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452528",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0963fa4205ab3982ba0f4e3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452530",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_610a3e7881c6402b50396ff5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "87452531",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cb9742ebf3369c0d2be7f7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "yardi",
      "external_id": "120692082",
      "title": "Laminate Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7f4e87c6d64be4abcdf3e5f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-8154-77d2-b42c-a945a52cc947.webp",
      "image_media": {
        "alt_text": "Strawberry Lane Apartment Homes monument sign",
        "public_id": "01a07555-8154-77d2-b42c-a945a52cc947",
        "storage_key": "property/6767906449167261/01a07555-8154-77d2-b42c-a945a52cc947.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Monument sign for Strawberry Lane Apartment Homes, with a building and landscaping in the background.",
      "link": "false",
      "alt_text": "Strawberry Lane Apartment Homes monument sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (31).JPG"
    },
    {
      "id": "ec_fa90350c3432dfe4ae16c97f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-9a0a-762d-8342-2cc465b8e376.webp",
      "image_media": {
        "alt_text": "Kitchen with white stovetop and oven, wood cabinets, and a light beige wall.",
        "public_id": "01a07555-9a0a-762d-8342-2cc465b8e376",
        "storage_key": "property/6767906449167261/01a07555-9a0a-762d-8342-2cc465b8e376.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space featuring a white electric stovetop and oven, complemented by warm wood cabinetry and a light beige wall.",
      "link": "false",
      "alt_text": "Kitchen with white stovetop and oven, wood cabinets, and a light beige wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (30).JPG"
    },
    {
      "id": "ec_676cae7d34e39040ac177a21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-9d92-77dd-aab4-9f4ff9debf94.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red and white siding, balconies, and a well-manicured lawn.",
        "public_id": "01a07555-9d92-77dd-aab4-9f4ff9debf94",
        "storage_key": "property/6767906449167261/01a07555-9d92-77dd-aab4-9f4ff9debf94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained grounds surround these apartment buildings, featuring red and white exteriors and private balconies, offering a comfortable living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with red and white siding, balconies, and a well-manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (29).JPG"
    },
    {
      "id": "ec_0c97fbc6a1d964c1502ab9ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-9a08-7623-9ed2-e13c1d1ad1dd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green grass and blue sky.",
        "public_id": "01a07555-9a08-7623-9ed2-e13c1d1ad1dd",
        "storage_key": "property/6767906449167261/01a07555-9a08-7623-9ed2-e13c1d1ad1dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Bright exterior view of apartment buildings with lush green lawns and a clear blue sky overhead. Features balconies and surrounding trees.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with green grass and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (28).JPG"
    },
    {
      "id": "ec_eb932436b2b13b1b9c4c542f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-9cc4-765d-a44d-001667c9317e.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and doorway to hallway.",
        "public_id": "01a07555-9cc4-765d-a44d-001667c9317e",
        "storage_key": "property/6767906449167261/01a07555-9cc4-765d-a44d-001667c9317e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Empty bedroom featuring plush carpeting, a standard closet with a hanging rod, and a doorway leading to a hallway with additional rooms.",
      "link": "false",
      "alt_text": "Bedroom with closet and doorway to hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (27).JPG"
    },
    {
      "id": "ec_db80c7d60839ec440c9c94be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-9ccb-77ae-a043-9114114b60ac.webp",
      "image_media": {
        "alt_text": "Kitchen with a double sink, stove, dishwasher, and refrigerator.",
        "public_id": "01a07555-9ccb-77ae-a043-9114114b60ac",
        "storage_key": "property/6767906449167261/01a07555-9ccb-77ae-a043-9114114b60ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a double sink, stove, dishwasher, and refrigerator, perfect for all your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with a double sink, stove, dishwasher, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (26).JPG"
    },
    {
      "id": "ec_8ffa6f5d29b76bedf1491696",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-c3ee-75e9-bc5b-1f621c7844d7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with carpet and white walls",
        "public_id": "01a07555-c3ee-75e9-bc5b-1f621c7844d7",
        "storage_key": "property/6767906449167261/01a07555-c3ee-75e9-bc5b-1f621c7844d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area that opens to a kitchen bar with ample counter space and cabinets. Neutral carpet throughout.",
      "link": "false",
      "alt_text": "Living room and kitchen area with carpet and white walls",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (25).JPG"
    },
    {
      "id": "ec_8eadcc437a2306e86a690244",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-c6f0-769a-a640-d29310e82adb.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and shelving unit with towels and decorative jars. Opens to a carpeted room.",
        "public_id": "01a07555-c6f0-769a-a640-d29310e82adb",
        "storage_key": "property/6767906449167261/01a07555-c6f0-769a-a640-d29310e82adb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom vanity featuring a sink, mirror, and ample shelving. Step into the adjoining carpeted room for extra living space.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and shelving unit with towels and decorative jars. Opens to a carpeted room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (24).JPG"
    },
    {
      "id": "ec_e17a8f5116ea94f8e42ab952",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-cc00-77bb-bde5-613a55456e85.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a white vanity, sink, toilet, and shower/tub combo.",
        "public_id": "01a07555-cc00-77bb-bde5-613a55456e85",
        "storage_key": "property/6767906449167261/01a07555-cc00-77bb-bde5-613a55456e85.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a white vanity with a sink, a toilet, and a shower/tub combination with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Clean bathroom with a white vanity, sink, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (23).JPG"
    },
    {
      "id": "ec_7d14be1672cf92a4fb83cafb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-d314-70c8-981f-8d66add6a2be.webp",
      "image_media": {
        "alt_text": "A compact kitchen with light wood cabinets, white countertops, a double sink, dishwasher, refrigerator, and electric stove.",
        "public_id": "01a07555-d314-70c8-981f-8d66add6a2be",
        "storage_key": "property/6767906449167261/01a07555-d314-70c8-981f-8d66add6a2be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment kitchen features light wood cabinetry, white countertops, a double sink, dishwasher, refrigerator, and a white electric stove, offering a functional cooking space.",
      "link": "false",
      "alt_text": "A compact kitchen with light wood cabinets, white countertops, a double sink, dishwasher, refrigerator, and electric stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (22).JPG"
    },
    {
      "id": "ec_d3943bf9e9716cd80d838983",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022a-c979-764e-a488-0667a52880d3.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and a baseboard heater",
        "public_id": "019d022a-c979-764e-a488-0667a52880d3",
        "storage_key": "property/6767906449167261/019d022a-c979-764e-a488-0667a52880d3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom with neutral walls and carpet, featuring a large window and baseboard heating for comfort.",
      "link": "false",
      "alt_text": "Empty bedroom with a window and a baseboard heater",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (21).JPG"
    },
    {
      "id": "ec_3b294cb9f6c343782778b4e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-d81a-70f9-8d6f-79c0a78b9e4b.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, armchair, and floor lamp.",
        "public_id": "01a07555-d81a-70f9-8d6f-79c0a78b9e4b",
        "storage_key": "property/6767906449167261/01a07555-d81a-70f9-8d6f-79c0a78b9e4b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living room, featuring comfortable seating and ample space for entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, armchair, and floor lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (20).jpg"
    },
    {
      "id": "ec_965ef7d05abf21bcf3816d6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-e6a3-76ac-86db-6827dffa4100.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white countertops, sink, dishwasher, refrigerator, and stove.",
        "public_id": "01a07555-e6a3-76ac-86db-6827dffa4100",
        "storage_key": "property/6767906449167261/01a07555-e6a3-76ac-86db-6827dffa4100.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, a double sink, modern appliances including a refrigerator, dishwasher, and electric stove.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white countertops, sink, dishwasher, refrigerator, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (19).jpg"
    },
    {
      "id": "ec_ce1f9056212c71cd8b127fdf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-ed39-73bf-9032-0127f7e78be6.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a large window.",
        "public_id": "01a07555-ed39-73bf-9032-0127f7e78be6",
        "storage_key": "property/6767906449167261/01a07555-ed39-73bf-9032-0127f7e78be6.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover comfortable living in this spacious primary bedroom, featuring a plush queen-size bed, convenient nightstands, and a large window that fills the room with natural light.",
      "link": "false",
      "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (18).jpg"
    },
    {
      "id": "ec_58f5201ace8601f41f706a65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-ee62-71fa-80af-4800a43699aa.webp",
      "image_media": {
        "alt_text": "Empty living room with neutral carpet and doors.",
        "public_id": "01a07555-ee62-71fa-80af-4800a43699aa",
        "storage_key": "property/6767906449167261/01a07555-ee62-71fa-80af-4800a43699aa.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "An empty living room with neutral carpeting, light yellow walls, and double doors. The space is ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty living room with neutral carpet and doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (17).jpg"
    },
    {
      "id": "ec_b1845d67fa47a783721eb740",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/01a07555-f4a8-737a-b6dd-d5fef945bb1c.webp",
      "image_media": {
        "alt_text": "Living area and kitchen view",
        "public_id": "01a07555-f4a8-737a-b6dd-d5fef945bb1c",
        "storage_key": "property/6767906449167261/01a07555-f4a8-737a-b6dd-d5fef945bb1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a carpeted floor and an open view to the kitchen. Perfect for modern living.",
      "link": "false",
      "alt_text": "Living area and kitchen view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Strawberry-Lane_Favorites (32).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c5fdae2d-658d-47e7-ac15-ce698dadf35b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Kaladi Brothers Coffee",
      "poi_type": "Restaurants",
      "poi_address": "6861 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_long_description": "Coffeehouse chain offering hot & cold brews made with air-roasted beans in a hip space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-4e8f-76ab-8539-817e5bda7c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-4e8f-76ab-8539-817e5bda7c0d",
        "storage_key": "property/6767906449167261/019f3ea5-4e8f-76ab-8539-817e5bda7c0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kaladi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3038128768890234705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaladi-brothers-coffee",
      "poi_latitude": "61.15817870000001",
      "poi_longitude": "-149.9509915",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-222-0949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3f01-73ef-9ac7-6d98a97326b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3f01-73ef-9ac7-6d98a97326b7",
        "storage_key": "property/6767906449167261/019d022b-3f01-73ef-9ac7-6d98a97326b7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJTRvzlw-YyFYRUeeYwwSaKSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_955b8b74-dc2c-4586-9a37-f9af7aa0416b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Uncle Joe's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "6839 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Casual spot offering stone-baked pizzas, plus craft beer, hoagies & other comfort fare.",
      "poi_long_description": "Casual spot offering stone-baked pizzas, plus craft beer, hoagies & other comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-4c40-72ff-a306-3f696bb6cc10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-4c40-72ff-a306-3f696bb6cc10",
        "storage_key": "property/6767906449167261/019f3ea5-4c40-72ff-a306-3f696bb6cc10.webp",
        "width": 972,
        "height": 862
      },
      "poi_business_url": "http://www.unclejoespizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11478748313861963113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncle-joes-pizzeria",
      "poi_latitude": "61.158327",
      "poi_longitude": "-149.9510063",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-248-9404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0pYmw-YyFYRaT3bQca0TJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e112a823-8667-4403-8536-8328209acdcb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Ronnie Sushi | Modern Japanese Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "8901 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Traditional and modern Japanese cuisine presented in a warm, colorful space with booths & sushi bar.",
      "poi_long_description": "Traditional and modern Japanese cuisine presented in a warm, colorful space with booths & sushi bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-4eea-71fa-8d05-62b7d29d2aaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-4eea-71fa-8d05-62b7d29d2aaf",
        "storage_key": "property/6767906449167261/019f3ea5-4eea-71fa-8d05-62b7d29d2aaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ronniesushiak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7818808689474578436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ronnie-sushi--modern-japanese-cuisine",
      "poi_latitude": "61.13952889999999",
      "poi_longitude": "-149.9513077",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-929-3442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQR6m2mYyFYRBKjexhP9gWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_bcac8a5f-7f16-41a2-b9b8-b2af53d10d59",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Marwin | Thai Cafe",
      "poi_type": "Restaurants",
      "poi_address": "8809 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://marwinthaicafeak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6217473804260237634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marwin--thai-cafe",
      "poi_latitude": "61.1404529",
      "poi_longitude": "-149.9501621",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWmdawCZyFYRQmE6v3vnSFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_8e15dc90-b3e8-4796-985c-8ebe9fe7609d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Kincaid Grill",
      "poi_type": "Restaurants",
      "poi_address": "6700 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "New American dishes feature local seafood & game, served in a white-tablecloth setting with a patio.",
      "poi_long_description": "New American dishes feature local seafood & game, served in a white-tablecloth setting with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-51b3-7748-a227-d081ff0d5fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-51b3-7748-a227-d081ff0d5fae",
        "storage_key": "property/6767906449167261/019f3ea5-51b3-7748-a227-d081ff0d5fae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kincaidgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1187193145682945907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-grill",
      "poi_latitude": "61.15994169999999",
      "poi_longitude": "-149.9527306",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-243-0507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5vPfA-YyFYRc-c1QODBeRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_dc65a4a6-b294-4904-9be0-d846110d0164",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Tastee Freez",
      "poi_type": "Restaurants",
      "poi_address": "3901 Raspberry Rd #1, Anchorage, AK 99502, USA",
      "poi_short_description": "Fast-food chain known for frozen treats also selling burgers, hot dogs & classic sides.",
      "poi_long_description": "Fast-food chain known for frozen treats also selling burgers, hot dogs & classic sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-51b0-76fd-b44f-c309668b75f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-51b0-76fd-b44f-c309668b75f9",
        "storage_key": "property/6767906449167261/019f3ea5-51b0-76fd-b44f-c309668b75f9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.tfalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16104476253928506305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tastee-freez",
      "poi_latitude": "61.15939699999999",
      "poi_longitude": "-149.954108",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-248-3068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9R3QbQ-YyFYRwUMf6dOXft8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_084e31e2-40ce-4afc-b9bb-a4db945e71b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Shanghai Tea Garden | Chinese • Dim Sum",
      "poi_type": "Restaurants",
      "poi_address": "9150 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Casual spot offering a mix of classic Chinese dishes and pizza in a laid-back setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022a-f113-7320-b561-744038c8e7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-f113-7320-b561-744038c8e7cc",
        "storage_key": "property/6767906449167261/019d022a-f113-7320-b561-744038c8e7cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://shanghaiteagardenak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17424305924396838981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shanghai-tea-garden--chinese--dim-sum",
      "poi_latitude": "61.1382205",
      "poi_longitude": "-149.9526811",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-243-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2GXymmYyFYRRXBomeuRz_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_b4590373-8dfe-4db0-843b-252ff3fafcae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-4c90-7203-ae46-26d320fb9942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-4c90-7203-ae46-26d320fb9942",
        "storage_key": "property/6767906449167261/019f3ea5-4c90-7203-ae46-26d320fb9942.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3f01-73ef-9ac7-6d98a97326b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3f01-73ef-9ac7-6d98a97326b7",
        "storage_key": "property/6767906449167261/019d022b-3f01-73ef-9ac7-6d98a97326b7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_81c98b5e-c72b-4b7f-8154-fb41a2023491",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Spenard Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1049 W Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_long_description": "Varied fare (such as Thai curry, burgers & pizza), plus beer & cocktails in a bright, casual eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022a-f678-7182-bd3f-9b54f69b59fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-f678-7182-bd3f-9b54f69b59fd",
        "storage_key": "property/6767906449167261/019d022a-f678-7182-bd3f-9b54f69b59fd.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.spenardroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079478686688268729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spenard-roadhouse",
      "poi_latitude": "61.19552819999999",
      "poi_longitude": "-149.9032167",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-770-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAGpNuXyFYRudEsUXaA4Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_962c8fe1-a77b-4311-afb5-b42a2f46fb49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-4d61-7508-b880-9b70925345c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-4d61-7508-b880-9b70925345c3",
        "storage_key": "property/6767906449167261/019f3ea3-4d61-7508-b880-9b70925345c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.8691037",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_0a22db44-24cc-4177-b0cd-62d47aaf8eed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Crow's Nest",
      "poi_type": "Restaurants",
      "poi_address": "939 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_long_description": "High-end restaurant offering French & New American cuisine, an extensive wine list & scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-4efa-74bb-9711-29262e681b86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-4efa-74bb-9711-29262e681b86",
        "storage_key": "property/6767906449167261/019f3ea5-4efa-74bb-9711-29262e681b86.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.captaincook.com/dining/crows-nest",
      "poi_directions_map_url": "https://maps.google.com/?cid=3666166427093759864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crows-nest",
      "poi_latitude": "61.21777780000001",
      "poi_longitude": "-149.9",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUUNNIG9yFYRePdi9vDW4DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_86b377bf-a4f4-47d7-9f2c-044b5c926563",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-4e85-743b-8aab-062f48855fb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-4e85-743b-8aab-062f48855fb3",
        "storage_key": "property/6767906449167261/019f3ea3-4e85-743b-8aab-062f48855fb3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_29f62a92-6bed-49a7-b25c-b681cb279463",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Humpy's Great Alaskan Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "610 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_long_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-4141-7714-b12d-90bda64f172f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-4141-7714-b12d-90bda64f172f",
        "storage_key": "property/6767906449167261/019f3ea3-4141-7714-b12d-90bda64f172f.webp",
        "width": 904,
        "height": 720
      },
      "poi_business_url": "https://www.humpysalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2859243613023281808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "humpys-great-alaskan-alehouse",
      "poi_latitude": "61.216342",
      "poi_longitude": "-149.894083",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3efc-76b1-82c2-edbf168b3476",
        "storage_key": "property/6767906449167261/019d022b-3efc-76b1-82c2-edbf168b3476.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14LWxYC9yFYRkKKOyOoSric",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c63e44ef-5607-46bb-814c-48c6c2b6e7f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5474-74f7-a6f3-6490141c1c41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5474-74f7-a6f3-6490141c1c41",
        "storage_key": "property/6767906449167261/019f3ea5-5474-74f7-a6f3-6490141c1c41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/4000-w-dimond-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6030287796882115306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.136418",
      "poi_longitude": "-149.953534",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-339-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3f04-70cc-bae4-59626d167cde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3f04-70cc-bae4-59626d167cde",
        "storage_key": "property/6767906449167261/019d022b-3f04-70cc-bae4-59626d167cde.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRqTZmiYyFYR6gqIKs3ir1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c97b71f6-adc6-43ca-b1d9-9346e7a6cb00",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022a-faa3-76fb-a097-3866e759730a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-faa3-76fb-a097-3866e759730a",
        "storage_key": "property/6767906449167261/019d022a-faa3-76fb-a097-3866e759730a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/dimond/701/00071?cid=loc_70100071_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328825712428702824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.1360991",
      "poi_longitude": "-149.9192402",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-267-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-3f04-70cc-bae4-59626d167cde.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-3f04-70cc-bae4-59626d167cde",
        "storage_key": "property/6767906449167261/019d022b-3f04-70cc-bae4-59626d167cde.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZf8OEiYyFYRaNx_PFldMi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eaae7a05-e71e-4f90-92f0-0a6a4b96fb01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022a-fb5e-70ed-aa94-ab30a85fdf0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022a-fb5e-70ed-aa94-ab30a85fdf0c",
        "storage_key": "property/6767906449167261/019d022a-fb5e-70ed-aa94-ab30a85fdf0c.webp",
        "width": 1280,
        "height": 343
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/anchorage-AK-10.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073767655837963207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.1435365",
      "poi_longitude": "-149.884555",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-349-2335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-433c-76fd-a7b1-daa69383c1e9",
        "storage_key": "property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK_i7Yc2ZyFYRx5N6toBbSlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_77677212-040b-48ec-88e7-4dd111435147",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2197 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5678-7218-b133-35a83e65cf93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5678-7218-b133-35a83e65cf93",
        "storage_key": "property/6767906449167261/019f3ea5-5678-7218-b133-35a83e65cf93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2197+w+dimond+blvd-anchorage-ak-99515/id=12680",
      "poi_directions_map_url": "https://maps.google.com/?cid=10156035882271767130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1381246",
      "poi_longitude": "-149.9197624",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-339-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTyZEUiYyFYRWvrtcNN88Yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d82c1247-30aa-4f46-899e-08829bbedb29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "8803 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Gas station chain featuring convenience stores selling grab-&-go meals, snacks & drinks.",
      "poi_long_description": "Gas station chain featuring convenience stores selling grab-&-go meals, snacks & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-55c4-7483-9862-a47f2396b377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-55c4-7483-9862-a47f2396b377",
        "storage_key": "property/6767906449167261/019f3ea5-55c4-7483-9862-a47f2396b377.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/8803-jewel-lake-rd/2746624?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5539581851827193431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.14062260000001",
      "poi_longitude": "-149.95149",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-243-5639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-82d2-75a6-9337-f45226fd4d2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3ea5-82d2-75a6-9337-f45226fd4d2e",
        "storage_key": "property/6767906449167261/019f3ea5-82d2-75a6-9337-f45226fd4d2e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ_2g11WuYyFYRV0ZcIliM4Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7fc501af-7058-48e7-a438-725048174a8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Anchorage Wine House at Jewel Lake",
      "poi_type": "Shopping & Retail",
      "poi_address": "8841 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-56d3-713f-a597-40b0feeef096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-56d3-713f-a597-40b0feeef096",
        "storage_key": "property/6767906449167261/019f3ea5-56d3-713f-a597-40b0feeef096.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.anchoragewinehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10554496576970308580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-wine-house-at-jewel-lake",
      "poi_latitude": "61.14037330000001",
      "poi_longitude": "-149.9502793",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-243-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-433c-76fd-a7b1-daa69383c1e9",
        "storage_key": "property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrwcAgmmYyFYR5DtkdbcaeZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_90e128c6-3927-40a5-8da7-c6461ae25054",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Dimond Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_long_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-4198-778e-90e4-5b30293d35e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-4198-778e-90e4-5b30293d35e5",
        "storage_key": "property/6767906449167261/019f3ea3-4198-778e-90e4-5b30293d35e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dimondcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335366531638308692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-center",
      "poi_latitude": "61.1438157",
      "poi_longitude": "-149.8691231",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-344-2581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-433c-76fd-a7b1-daa69383c1e9",
        "storage_key": "property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRVC8_E8ksiBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_52457c36-b91c-4541-8379-a2894c5dc22c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "8900 Old Seward Hwy, Anchorage, AK 99515, USA",
      "poi_short_description": "Chain department store selling everything from clothing and housewares to electronics and baby supplies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-0528-710d-a3af-68f1bac05a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-0528-710d-a3af-68f1bac05a90",
        "storage_key": "property/6767906449167261/019d022b-0528-710d-a3af-68f1bac05a90.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2071-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18227266214841406995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.1402087",
      "poi_longitude": "-149.8698771",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-344-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-433c-76fd-a7b1-daa69383c1e9",
        "storage_key": "property/6767906449167261/019d022b-433c-76fd-a7b1-daa69383c1e9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-ThFGNCZyFYRE9YZ2gxC9Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_839c5293-0b87-47c7-a1fa-82b1cdbea6fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Big Mike’s Service Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7211 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Convenience store and service station with an on-site auto repair shop offering fuel, tires, and oil changes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5931-73b9-9b8f-b52bce7131ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5931-73b9-9b8f-b52bce7131ce",
        "storage_key": "property/6767906449167261/019f3ea5-5931-73b9-9b8f-b52bce7131ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/BigMikesTesoro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8277229491644172047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-mikes-service-center",
      "poi_latitude": "61.155359",
      "poi_longitude": "-149.9513885",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-243-2134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaVYHw6YyFYRD4fWNV6g3nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_repair"
    },
    {
      "id": "custom_ee071236-a898-41a0-86de-5e9db1868f39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Chinook Elementary School",
      "poi_type": "Education",
      "poi_address": "3101 W 88th Ave, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://chinook.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16534007879363010667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chinook-elementary-school",
      "poi_latitude": "61.14149210000001",
      "poi_longitude": "-149.9392938",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSSqa90CYyFYRayDxupCYdOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d996c88c-c5b5-4d39-a412-ad3d2f5ba66d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Dimond High School",
      "poi_type": "Education",
      "poi_address": "2909 W 88th Ave, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5a3d-721a-8753-db5a9a95b24f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5a3d-721a-8753-db5a9a95b24f",
        "storage_key": "property/6767906449167261/019f3ea5-5a3d-721a-8753-db5a9a95b24f.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://dimond.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2813943904138793670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-high-school",
      "poi_latitude": "61.1428073",
      "poi_longitude": "-149.9345106",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUNDQj-YyFYRxpIRaBIjDSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c36e19ee-d9e7-4572-bdb3-0dd9159f42eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Mears Middle School",
      "poi_type": "Education",
      "poi_address": "2700 W 100th Ave, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/mears",
      "poi_directions_map_url": "https://maps.google.com/?cid=11455003443888380767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mears-middle-school",
      "poi_latitude": "61.1292672",
      "poi_longitude": "-149.931338",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe-vwR1CYyFYRX9vX5fBY-J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ce7738cd-d9f3-4ba5-8cc1-1a02a5aab5ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Sand Lake Elementary School",
      "poi_type": "Education",
      "poi_address": "7500 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-246e-7581-a8c9-1742db6a41a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-246e-7581-a8c9-1742db6a41a5",
        "storage_key": "property/6767906449167261/019d022b-246e-7581-a8c9-1742db6a41a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sandlake.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13183788841403188263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-lake-elementary-school",
      "poi_latitude": "61.1525443",
      "poi_longitude": "-149.9536856",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-243-2161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxvWEBKYyFYRJ4SYvRk69rY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a910508e-44c1-48cc-8acf-250b667946f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Kincaid Elementary School",
      "poi_type": "Education",
      "poi_address": "4900 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/kincaid",
      "poi_directions_map_url": "https://maps.google.com/?cid=6266479471330070282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-elementary-school",
      "poi_latitude": "61.15734029999999",
      "poi_longitude": "-149.9704028",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-245-5530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU_gFPQqYyFYRCg_owOAB91Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_34848850-a437-4693-bd8a-38efa36767cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Gladys Wood Elementary School",
      "poi_type": "Education",
      "poi_address": "7001 Cranberry St, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/gladyswood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2247644557951018680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gladys-wood-elementary-school",
      "poi_latitude": "61.1571678",
      "poi_longitude": "-149.9355727",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-6760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Wr6HRqYyFYRuKYCItE8MR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c153072d-7379-42c7-b151-27462d05006b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Children's World Bilingual Montessori",
      "poi_type": "Education",
      "poi_address": "7423 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://cwbilingualmontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15403854944102128811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-world-bilingual-montessori",
      "poi_latitude": "61.1534365",
      "poi_longitude": "-149.951017",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-349-4182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7VHX9RGYyFYRqxzaYnV8xdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f8c956b1-ccbe-4f1a-8761-936df80d6c8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Growing together bilingual daycare",
      "poi_type": "Education",
      "poi_address": "3130 Rosalind Loop, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5a60-76df-9f4d-7c01a76b3adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5a60-76df-9f4d-7c01a76b3adb",
        "storage_key": "property/6767906449167261/019f3ea5-5a60-76df-9f4d-7c01a76b3adb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469555602232375472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "growing-together-bilingual-daycare",
      "poi_latitude": "61.1422661",
      "poi_longitude": "-149.8253595",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvylbBQ-XyFYRsPiyBYt6yFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_fcb4ffae-b66a-452c-9dee-bc0dc5623ef7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Crystal CDC",
      "poi_type": "Education",
      "poi_address": "6821 Weimer Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5a3e-7628-be57-79132eaedd5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5a3e-7628-be57-79132eaedd5e",
        "storage_key": "property/6767906449167261/019f3ea5-5a3e-7628-be57-79132eaedd5e.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "https://crystalcdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788941550791674781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-cdc",
      "poi_latitude": "61.15889929999999",
      "poi_longitude": "-149.9487627",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-929-2643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK2E_9A-YyFYRncuPk0gpXL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c2da9dd9-0b40-403f-ad74-e83d4acc4923",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-41f1-7423-b8b1-31935a3df446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-41f1-7423-b8b1-31935a3df446",
        "storage_key": "property/6767906449167261/019f3ea3-41f1-7423-b8b1-31935a3df446.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.8195598",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_77a35a05-3fd7-4bd0-9ac9-d37a032186f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Cinemark Century Anchorage 16 and XD",
      "poi_type": "Entertainment",
      "poi_address": "301 E 36th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5e3d-7548-bae2-820837052604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5e3d-7548-bae2-820837052604",
        "storage_key": "property/6767906449167261/019f3ea5-5e3d-7548-bae2-820837052604.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ak-anchorage/cinemark-century-anchorage-16-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5OTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722013179919255636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-century-anchorage-16-and-xd",
      "poi_latitude": "61.18909729999999",
      "poi_longitude": "-149.8792298",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-770-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4383-7518-8c01-3852656f0e3a",
        "storage_key": "property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxEYXseXyFYRVMh83mOGEOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9c2dbd85-9539-42a0-9078-aa607f813cee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Regal Dimond Center",
      "poi_type": "Entertainment",
      "poi_address": "800 E Dimond Blvd #201, Anchorage, AK 99515, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-0853-76fe-86f5-43dbba72a108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-0853-76fe-86f5-43dbba72a108",
        "storage_key": "property/6767906449167261/019d022b-0853-76fe-86f5-43dbba72a108.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-dimond-center-cinemas-0922?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18078743811721282702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-dimond-center",
      "poi_latitude": "61.14334389999999",
      "poi_longitude": "-149.8680313",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4383-7518-8c01-3852656f0e3a",
        "storage_key": "property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRjkTwIraZ5Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_807e7c15-5690-45e3-b924-6811a7f38646",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5fbd-757d-86b4-c017bc3de366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5fbd-757d-86b4-c017bc3de366",
        "storage_key": "property/6767906449167261/019f3ea5-5fbd-757d-86b4-c017bc3de366.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4383-7518-8c01-3852656f0e3a",
        "storage_key": "property/6767906449167261/019d022b-4383-7518-8c01-3852656f0e3a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_121b3f44-7c16-41e6-a4be-82225c14a8ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-09c8-77ca-8e6e-177f306bddd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-09c8-77ca-8e6e-177f306bddd1",
        "storage_key": "property/6767906449167261/019d022b-09c8-77ca-8e6e-177f306bddd1.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4349-7675-8496-0aa2bf264e5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4349-7675-8496-0aa2bf264e5c",
        "storage_key": "property/6767906449167261/019d022b-4349-7675-8496-0aa2bf264e5c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6c8f11c3-0085-4719-a112-e663987c61ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-5eac-735f-b4e8-f4728a23f813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-5eac-735f-b4e8-f4728a23f813",
        "storage_key": "property/6767906449167261/019f3ea5-5eac-735f-b4e8-f4728a23f813.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_c784e513-50a6-43c5-8f09-e49c11aa72bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-539d-72f7-bb5f-c04536dab8d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-539d-72f7-bb5f-c04536dab8d3",
        "storage_key": "property/6767906449167261/019f3ea3-539d-72f7-bb5f-c04536dab8d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.9719066",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4349-7675-8496-0aa2bf264e5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4349-7675-8496-0aa2bf264e5c",
        "storage_key": "property/6767906449167261/019d022b-4349-7675-8496-0aa2bf264e5c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_57f77f9c-7792-4469-9787-7369214eea77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Kincaid Outdoor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6095-763f-9c41-a1fabf902e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6095-763f-9c41-a1fabf902e62",
        "storage_key": "property/6767906449167261/019f3ea5-6095-763f-9c41-a1fabf902e62.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4482038648302601019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-outdoor-center",
      "poi_latitude": "61.15422419999999",
      "poi_longitude": "-150.0565216",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0U0ufCiyFYROwOmXWdmMz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "picnic_ground"
    },
    {
      "id": "custom_c4d5c7b4-c163-401c-b80e-843807a2cca7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Point Woronzof Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9700 Point Woronzof Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_long_description": "Large wooded area with trails for hiking, running, bicycling & cross-country skiing seasonally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-9ea9-75be-8608-a690e569286f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-9ea9-75be-8608-a690e569286f",
        "storage_key": "property/6767906449167261/019d022b-9ea9-75be-8608-a690e569286f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3646899879165127207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "point-woronzof-park",
      "poi_latitude": "61.2011236",
      "poi_longitude": "-150.0203185",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7F3TS29yFYRJ2oNNR5knDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_154dc30d-b9ba-42b1-aa92-99aea570091e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-532a-71f5-948d-2b35a7eb27f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-532a-71f5-948d-2b35a7eb27f2",
        "storage_key": "property/6767906449167261/019f3ea3-532a-71f5-948d-2b35a7eb27f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_21dec67f-30d9-429e-85c2-0af858a14229",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-5ef2-737a-ae36-85190166f13d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-5ef2-737a-ae36-85190166f13d",
        "storage_key": "property/6767906449167261/019f3ea3-5ef2-737a-ae36-85190166f13d.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_56a0d2ff-946f-4f18-afb7-13ce53a2a56b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-5ce7-7472-b3c1-76199a028e9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-5ce7-7472-b3c1-76199a028e9f",
        "storage_key": "property/6767906449167261/019f3ea3-5ce7-7472-b3c1-76199a028e9f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.8221354",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4817-7448-832c-770c9ca020dd",
        "storage_key": "property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_e0775bf4-7d71-40a6-9e73-552fe2054499",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Urgent Care Medical Clinic, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "9150 Jewel Lake Rd Ste B, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://alaskaurgentcaremedicalclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14895501792456999093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-medical-clinic-llc",
      "poi_latitude": "61.1383094",
      "poi_longitude": "-149.9527802",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2GXymmYyFYRtQCY4vVzt84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c8033990-9a92-4d12-a471-e9d3d4ace288",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "AMS Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3401 Minnesota Dr #100, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-64c9-714d-9530-21bdc059b30e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-64c9-714d-9530-21bdc059b30e",
        "storage_key": "property/6767906449167261/019f3ea5-64c9-714d-9530-21bdc059b30e.webp",
        "width": 840,
        "height": 1280
      },
      "poi_business_url": "http://amsurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805240541233911751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ams-urgent-care",
      "poi_latitude": "61.1891074",
      "poi_longitude": "-149.9123992",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-677-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwZ1h92XyFYRx5etW21atbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4e586bdf-c704-40a2-8d1e-99e6e823f6ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-1b4d-773c-b03d-2a3a7a975716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-1b4d-773c-b03d-2a3a7a975716",
        "storage_key": "property/6767906449167261/019d022b-1b4d-773c-b03d-2a3a7a975716.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/4000-w-dimond-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12104316294821389142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.1363996",
      "poi_longitude": "-149.9534225",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-339-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-57bbac163bb2",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRqTZmiYyFYRViPN6Ykr-6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e6da1b4b-7215-45fa-a916-a297bdea3c71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6793-71f4-8016-f6bfc1528612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6793-71f4-8016-f6bfc1528612",
        "storage_key": "property/6767906449167261/019f3ea5-6793-71f4-8016-f6bfc1528612.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00071?cid=loc_70100071P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10191980107924744542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.13601629999999",
      "poi_longitude": "-149.9193571",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-267-6733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-57bbac163bb2",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZf8OEiYyFYRXqmzougvcY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_75b5efe5-a809-4f1f-81aa-0b2d2ebc2166",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "150 W 100th Ave, Anchorage, AK 99515, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6659-7305-b80e-d969d3e40a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6659-7305-b80e-d969d3e40a88",
        "storage_key": "property/6767906449167261/019f3ea5-6659-7305-b80e-d969d3e40a88.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/anchorage-ak-pharmacies/150-w-100th-ave-anchorage-ak-99515/storeid=17436?WT.mc_id=LS_GOOGLE_RX_17436",
      "poi_directions_map_url": "https://maps.google.com/?cid=12474615104983967683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "61.1292845",
      "poi_longitude": "-149.8809329",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-267-7501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-57bbac163bb2",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-57bbac163bb2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfd0G7iZyFYRw6dKOli8Hq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_18b801bd-5819-4038-bcc8-c1f25fbd221b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "The Alaska Club Jewel Lake Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "3841 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-15cf-72cf-9e5e-fdeeb6fed18b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-15cf-72cf-9e5e-fdeeb6fed18b",
        "storage_key": "property/6767906449167261/019d022b-15cf-72cf-9e5e-fdeeb6fed18b.webp",
        "width": 932,
        "height": 604
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacjewel-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=12372678282628664161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-jewel-lake-gym",
      "poi_latitude": "61.1379345",
      "poi_longitude": "-149.9508895",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-365-7374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7URjAomZyFYRYYtFRFiVtKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c92f2d28-5b7c-4a92-b4c9-64d61ed40aee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Studio - Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3841 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6597-77cc-8ee2-d1873fb03a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6597-77cc-8ee2-d1873fb03a46",
        "storage_key": "property/6767906449167261/019f3ea5-6597-77cc-8ee2-d1873fb03a46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://studioakhotyoga.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-studioakhotyoga-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10056814649077451196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio---hot-yoga",
      "poi_latitude": "61.1379345",
      "poi_longitude": "-149.9508895",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-245-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm_v-y2mYyFYRvMk02qP7kIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_ee609066-8162-4f5b-8293-b9dbd8d0a87d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8936 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, personal training, and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-67ad-746d-9911-ba402840129a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-67ad-746d-9911-ba402840129a",
        "storage_key": "property/6767906449167261/019f3ea5-67ad-746d-9911-ba402840129a.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/anchorage-alaska-4023/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4023",
      "poi_directions_map_url": "https://maps.google.com/?cid=15154378622549450527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "61.1397399",
      "poi_longitude": "-149.8351745",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-600-2611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5JjnF6ZyFYRH1_V3BArT9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fa29b61e-1dee-4f7a-9a8e-f4e2ce34d12c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Studio One VASIE® Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "4007 Old Seward Hwy #900, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6a45-7578-9e7a-e5aaac139e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6a45-7578-9e7a-e5aaac139e52",
        "storage_key": "property/6767906449167261/019f3ea5-6a45-7578-9e7a-e5aaac139e52.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.vasieonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=468324441195412692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-one-vasie-pilates",
      "poi_latitude": "61.1840217",
      "poi_longitude": "-149.8670886",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-708-2743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT0w0d7yXyFYR1PwVFZnSfwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_edb592e6-068a-4b54-ba1e-5d7f71ca3736",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Chitose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7500 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6e44-734f-94ea-2524eb48dd2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6e44-734f-94ea-2524eb48dd2a",
        "storage_key": "property/6767906449167261/019f3ea5-6e44-734f-94ea-2524eb48dd2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=263312199664266408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chitose-park",
      "poi_latitude": "61.15276189999999",
      "poi_longitude": "-149.9560413",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5kzDQCZyFYRqOwD7gx5pwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2e9ea051-58e0-4f00-af3e-3351acb033f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Connors Bog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5404 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Park featuring trails through woods and a bog, with moose sightings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6962-7397-b19d-8e871892b355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6962-7397-b19d-8e871892b355",
        "storage_key": "property/6767906449167261/019f3ea5-6962-7397-b19d-8e871892b355.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/PublishingImages/OffLeashDogParkAreas/ConnorsBog.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=14765569481671853910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "connors-bog-park",
      "poi_latitude": "61.1719114",
      "poi_longitude": "-149.9377531",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIeQ1Hf-XyFYRVkdmVTbX6cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dba1d28e-fca9-4804-a7a6-e26fd25cc221",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Jewel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_long_description": "Lakefront getaway providing a swimming beach, picnic pavilion & children's play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6a03-767d-908e-ae0b99925d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6a03-767d-908e-ae0b99925d10",
        "storage_key": "property/6767906449167261/019f3ea5-6a03-767d-908e-ae0b99925d10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3912813866064468304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jewel-lake-park",
      "poi_latitude": "61.1411207",
      "poi_longitude": "-149.9595208",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-FffG6YyFYRUNn-7nobTTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b7dd6240-1c77-4544-9ac3-87b470a14162",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "DeLong Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6420 Jewel Lake Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Popular, urban park with a lake offering swimming, fishing & kayaking, plus a forested walking path.",
      "poi_long_description": "Popular, urban park with a lake offering swimming, fishing & kayaking, plus a forested walking path.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6bd8-7719-9a7e-29c58af258d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6bd8-7719-9a7e-29c58af258d6",
        "storage_key": "property/6767906449167261/019f3ea5-6bd8-7719-9a7e-29c58af258d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11394991520899816937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delong-lake-park",
      "poi_latitude": "61.1639876",
      "poi_longitude": "-149.9541973",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQOgKQSYyFYR6V3SPWokI54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0199bb3e-fe12-41ae-905c-a7d0fe515ded",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Javier De La Vega Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1950 W 56th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6cb6-763a-a323-aa2d138f8778.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6cb6-763a-a323-aa2d138f8778",
        "storage_key": "property/6767906449167261/019f3ea5-6cb6-763a-a323-aa2d138f8778.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7922891530172065047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "javier-de-la-vega-park",
      "poi_latitude": "61.16870789999999",
      "poi_longitude": "-149.9218421",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUvriPOXyFYRF2Xbkd7D820",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9de17abe-275c-4165-acee-346a6d3a659c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Wolverine Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1006 W 74th Ave, Anchorage, AK 99518, USA",
      "poi_short_description": "Quiet green space featuring picnic tables and play areas for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7228-772d-98ff-f46a1b298031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7228-772d-98ff-f46a1b298031",
        "storage_key": "property/6767906449167261/019f3ea5-7228-772d-98ff-f46a1b298031.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4981258685420854565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wolverine-park",
      "poi_latitude": "61.1534552",
      "poi_longitude": "-149.8977204",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9xYsSiYyFYRJd3W7mH8IEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b8e09223-a16e-4d96-a9cd-5b5e2d15e03b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Brotherhood Sisterhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4910 Van Buren St, Anchorage, AK 99517, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-6eae-72ce-a91b-9531b79d2923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-6eae-72ce-a91b-9531b79d2923",
        "storage_key": "property/6767906449167261/019f3ea5-6eae-72ce-a91b-9531b79d2923.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/pages/parklisting.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13129113962482932798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brotherhood-sisterhood-park",
      "poi_latitude": "61.1766168",
      "poi_longitude": "-149.9233658",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4LWg_qXyFYRPpxqfZb7M7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_cc9e4a29-2b46-4262-9379-135a9d5f54ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Kincaid Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9401 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_long_description": "Hiking, biking & skiing along groomed trails (a third of which are lit) in a rolling, forested area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-5e20-70bd-a688-2f11268bf687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-5e20-70bd-a688-2f11268bf687",
        "storage_key": "property/6767906449167261/019f3ea3-5e20-70bd-a688-2f11268bf687.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/Kincaid.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15637430419620688250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kincaid-park",
      "poi_latitude": "61.1536409",
      "poi_longitude": "-150.05538",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxF8gvOiyFYRevFgsR1QA9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_60395d3e-2a9a-4075-ac19-8305acb7ef40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Little Campbell Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8801 Raspberry Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-734e-719a-a8f8-0cd0e3d83c71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-734e-719a-a8f8-0cd0e3d83c71",
        "storage_key": "property/6767906449167261/019f3ea5-734e-719a-a8f8-0cd0e3d83c71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.org/detail/little-campbell-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=16945797376955916151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-campbell-lake",
      "poi_latitude": "61.16344700000001",
      "poi_longitude": "-150.0233833",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54VPz_CiyFYRdx80ge6QK-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_99c34f18-b046-4186-9642-24184962335d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Pop Carr Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hampshire Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Relaxed park featuring playgrounds for kids of all ages, plus tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7095-75fb-b316-6966ee25e13e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7095-75fb-b316-6966ee25e13e",
        "storage_key": "property/6767906449167261/019f3ea5-7095-75fb-b316-6966ee25e13e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13678918657624959400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pop-carr-memorial-park",
      "poi_latitude": "61.1790321",
      "poi_longitude": "-149.9008818",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4857-7205-8b52-504118835b1c",
        "storage_key": "property/6767906449167261/019d022b-4857-7205-8b52-504118835b1c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38sZjOuXyFYRqOkyiwtI1b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d79695c1-0530-43bb-bd40-cc4aa18545c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Lake Otis & 80th Ave SSW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14400594253296538008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-otis--80th-ave-ssw",
      "poi_latitude": "61.14766499999999",
      "poi_longitude": "-149.834408",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3ea5-82d7-736b-b395-c84aacc94e9f",
        "storage_key": "property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWnH-WCXyFYRmJFF_iww2cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f69e9ab7-942a-4ae3-8430-646e1a6f5928",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Old Seward & 80th Avenue NNW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99518, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471453642280758203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-seward--80th-avenue-nnw",
      "poi_latitude": "61.148593",
      "poi_longitude": "-149.864289",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3ea5-82d7-736b-b395-c84aacc94e9f",
        "storage_key": "property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7YBTZ9aZyFYRu2u53udccYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_8a1dcc2e-5827-4925-adc5-40d8217dcc75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Lake Otis & 84th Avenue SSE",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7487-725f-aa55-b21ad4fa9cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7487-725f-aa55-b21ad4fa9cc1",
        "storage_key": "property/6767906449167261/019f3ea5-7487-725f-aa55-b21ad4fa9cc1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5844332788589691619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-otis--84th-avenue-sse",
      "poi_latitude": "61.143452",
      "poi_longitude": "-149.833844",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3ea5-82d7-736b-b395-c84aacc94e9f",
        "storage_key": "property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJeVcXBOCZyFYR44IO5bQ9G1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_44134dab-53fe-4a2c-a296-39ecfaf7b908",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-74ee-70a9-9c0a-627af747dea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-74ee-70a9-9c0a-627af747dea3",
        "storage_key": "property/6767906449167261/019f3ea5-74ee-70a9-9c0a-627af747dea3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.17707559999999",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_689f02bc-b7fd-4863-86b0-b71026944bbc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-78e0-7411-808a-7e05d209cca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-78e0-7411-808a-7e05d209cca9",
        "storage_key": "property/6767906449167261/019f3ea5-78e0-7411-808a-7e05d209cca9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f3ea5-82d7-736b-b395-c84aacc94e9f",
        "storage_key": "property/6767906449167261/019f3ea5-82d7-736b-b395-c84aacc94e9f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a2b887c4-edc8-48e3-b536-abfa2b7c635f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7937-7449-8acb-8425db656406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7937-7449-8acb-8425db656406",
        "storage_key": "property/6767906449167261/019f3ea5-7937-7449-8acb-8425db656406.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_3c067c3c-f0ae-4ca7-b39b-0def39894ce9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-6839-741f-8aa1-891596311ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-6839-741f-8aa1-891596311ee0",
        "storage_key": "property/6767906449167261/019f3ea3-6839-741f-8aa1-891596311ee0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.22168490000001",
      "poi_longitude": "-149.8904657",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c50-76b4-aef7-64ddaba08d41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c50-76b4-aef7-64ddaba08d41",
        "storage_key": "property/6767906449167261/019d022b-4c50-76b4-aef7-64ddaba08d41.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_85a3e780-b4d3-4c9a-aab2-4d1b7a410674",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea3-697e-77dd-98a3-f15bf07e07f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea3-697e-77dd-98a3-f15bf07e07f2",
        "storage_key": "property/6767906449167261/019f3ea3-697e-77dd-98a3-f15bf07e07f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c4c-7419-8ef1-162d3fb2c3bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c4c-7419-8ef1-162d3fb2c3bf",
        "storage_key": "property/6767906449167261/019d022b-4c4c-7419-8ef1-162d3fb2c3bf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_162907b4-ed11-4daa-ab5c-675969dc39e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-151f-72ec-b214-7e35c5c830c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-151f-72ec-b214-7e35c5c830c1",
        "storage_key": "property/6767906449167261/019d022b-151f-72ec-b214-7e35c5c830c1.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.8002427",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4817-7448-832c-770c9ca020dd",
        "storage_key": "property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8625b3ea-236a-4686-a999-415c529fcdc8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7a53-7129-8e5d-6ac2a946e487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7a53-7129-8e5d-6ac2a946e487",
        "storage_key": "property/6767906449167261/019f3ea5-7a53-7129-8e5d-6ac2a946e487.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4c33-738e-a77b-b2775fbe17c5",
        "storage_key": "property/6767906449167261/019d022b-4c33-738e-a77b-b2775fbe17c5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f8269f80-c5e2-4c2a-9cac-fcc08e0ed6aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-1519-706c-bc3a-51769230bc2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-1519-706c-bc3a-51769230bc2e",
        "storage_key": "property/6767906449167261/019d022b-1519-706c-bc3a-51769230bc2e.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2106829",
      "poi_longitude": "-149.8283619",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4817-7448-832c-770c9ca020dd",
        "storage_key": "property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f413d2b1-265d-4cb5-bca1-9eef3c4e84b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Southcentral Foundation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4320 Diplomacy Dr #2300, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.southcentralfoundation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3019730341503088136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southcentral-foundation",
      "poi_latitude": "61.1816621",
      "poi_longitude": "-149.7999688",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-729-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTcpchyXyFYRCLbCEr886Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_6e967626-ca97-4214-bb1f-b848633a09dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-343c-739b-a211-a6160f23ec66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d022b-343c-739b-a211-a6160f23ec66",
        "storage_key": "property/6767906449167261/019d022b-343c-739b-a211-a6160f23ec66.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.18400399999999",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4343-721b-aa69-3f3a9a1a3b87",
        "storage_key": "property/6767906449167261/019d022b-4343-721b-aa69-3f3a9a1a3b87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_06c4136a-e4d5-4091-9246-c580b249e80b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Anchorage VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7c1a-708f-822d-5908a3d33df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7c1a-708f-822d-5908a3d33df1",
        "storage_key": "property/6767906449167261/019f3ea5-7c1a-708f-822d-5908a3d33df1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.va.gov/locations/directions.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1810043390262328329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-va-medical-center",
      "poi_latitude": "61.23270319999999",
      "poi_longitude": "-149.7444828",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 888-353-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4817-7448-832c-770c9ca020dd",
        "storage_key": "property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYzvJi-UyFYRCTyhmN-QHhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_21c910b4-d8af-41f2-8864-877a875678cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "poi_name": "Joint Base Elmendorf-Richardson Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5955 Zeamer Ave, Elmendorf AFB, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f3ea5-7d5d-70ff-8640-3639c4808f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f3ea5-7d5d-70ff-8640-3639c4808f00",
        "storage_key": "property/6767906449167261/019f3ea5-7d5d-70ff-8640-3639c4808f00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://elmendorfrichardson.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6126920116019283537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-base-elmendorf-richardson-hospital",
      "poi_latitude": "61.235181",
      "poi_longitude": "-149.744925",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 907-580-2778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d022b-4817-7448-832c-770c9ca020dd",
        "storage_key": "property/6767906449167261/019d022b-4817-7448-832c-770c9ca020dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWeg8S6UyFYRUUaGOmIxB1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9b145078fe3a1aa1f651a0c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_419e71cd4e83461cfd5ba99a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7357071c983505aaf8b08964",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d71bdbf65b76a427e0eb3642",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a8cb9e25576313266469e77b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6b675f6c5dd92369674d4f23",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "rating": "5",
      "name": "Elly John",
      "text": "I had trouble with a few things in my apartment they send Augustine maintenance man over, he is so friendly @ very respectful.  Most important he gets the job done from start to finish! Especially on Christmas he came by to fix my stove, without him I would not had Christmas dinner! Thank you Agustine your the best!",
      "date": "2024-07-31",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d3ef1cf1-af53-4dc5-a652-3c6caf9036db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019ddcfe-33c0-73cc-b1ee-f54fd4b4c608.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfe-33c0-73cc-b1ee-f54fd4b4c608",
        "storage_key": "property/6767906449167261/019ddcfe-33c0-73cc-b1ee-f54fd4b4c608.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Two Bedroom One Bath (A)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9SYyv2FtVGQ"
    },
    {
      "id": "custom_bafd5695-ac03-496d-8ce5-33fa2e092a43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019ddcfe-33ff-74ed-80a7-6d7b3a5fe74f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfe-33ff-74ed-80a7-6d7b3a5fe74f",
        "storage_key": "property/6767906449167261/019ddcfe-33ff-74ed-80a7-6d7b3a5fe74f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Two Bedroom One Bath (B)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7UJ7nM9Z1Dp"
    },
    {
      "id": "custom_881b3c02-00b6-4637-a708-4e178860b184",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167261/019f8622-d001-754b-8cf2-7ca506681994.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8622-d001-754b-8cf2-7ca506681994",
        "storage_key": "property/6767906449167261/019f8622-d001-754b-8cf2-7ca506681994.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Strawberry Lane | Building 1801 - Apt. 06",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XdKq4uigLRQ"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f95f3-7a4f-77c2-a13c-896c9f7f990e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Strawberry Lane Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "dedicated-parking-apartments-anchorage",
      "search_query": "dedicated parking apartments Anchorage",
      "category": "Amenity",
      "h1_title": "Dedicated Parking Apartments in Anchorage",
      "h2_subtitle": "Looking for dedicated parking apartments in Anchorage? Strawberry Lane offers assigned parking spaces to all residents.",
      "page_copy": "Strawberry Lane Apartments in Anchorage provides a unique living experience with dedicated parking options. As a resident, you'll enjoy the convenience of an assigned parking space at no additional cost. Perfectly positioned in the Sand Lake neighborhood, our community ensures easy access to both your home and the best of Anchorage.\n\nIn addition to dedicated parking, our community is pet-friendly with pet stations and offers additional storage units, flexible lease terms, and private patios or balconies. Experience the comfort and convenience that come with a thoughtfully curated amenity package at Strawberry Lane.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dedicated Parking Apartments in Anchorage",
      "seo_description": "Discover dedicated parking apartments in Anchorage at Strawberry Lane, offering assigned spaces and more. Ideal location and amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "dishwasher-apartments-sand-lake",
      "search_query": "dishwasher apartments Sand Lake",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments in Sand Lake",
      "h2_subtitle": "Explore dishwasher-equipped apartments in Sand Lake. Strawberry Lane offers comfort with modern amenities.",
      "page_copy": "Nestled in the Sand Lake neighborhood, Strawberry Lane Apartments in Anchorage welcomes you to a life of convenience. Our apartments are equipped with dishwashers, making everyday chores a breeze. Enjoy the serenity of our community while accessing modern comforts and amenities designed to elevate your lifestyle.\n\nBeyond the convenience of a dishwasher, each of our residences features a private patio or balcony, free assigned parking, and additional storage options. We are a pet-friendly community with flexible lease terms, ensuring you find the perfect living arrangement tailored to your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments in Sand Lake",
      "seo_description": "Find dishwasher-equipped apartments in Sand Lake at Strawberry Lane. Enjoy modern amenities, private balconies, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-anchorage-municipality",
      "search_query": "private balcony apartments Anchorage Municipality",
      "category": "Amenity",
      "h1_title": "Private Balcony Apartments in Anchorage",
      "h2_subtitle": "Discover private balcony apartments in Anchorage Municipality. Enjoy scenic views right from your own home at Strawberry Lane.",
      "page_copy": "At Strawberry Lane Apartments, located within the Anchorage Municipality, residents can enjoy the luxury of private balconies. Each apartment is designed to provide you with a personal outdoor retreat, offering the perfect spot to unwind while taking in scenic views. Our community in Sand Lake blends convenience with tranquility, ensuring a comfortable living experience.\n\nIn addition to private balconies, our apartments come with pet-friendly facilities, assigned parking spaces, flexible lease terms, and additional storage units. Whether you're looking for a cozy retreat or a place to entertain friends, Strawberry Lane offers the ideal setting for any lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments in Anchorage",
      "seo_description": "Experience private balcony apartments in Anchorage Municipality at Strawberry Lane. Scenic views and modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-99502",
      "search_query": "pet-friendly apartments 99502",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in 99502",
      "h2_subtitle": "Find pet-friendly apartments in the 99502 area. Strawberry Lane welcomes pets with open arms and offers convenient amenities.",
      "page_copy": "For those seeking pet-friendly apartments in the 99502 area, Strawberry Lane is the perfect choice. Located in the heart of Anchorage, we proudly cater to pet owners by providing pet stations throughout our community. Our spacious layouts and private balconies ensure that both you and your pets can enjoy comfortable living.\n\nBeyond being pet-friendly, Strawberry Lane offers residents a range of amenities including free assigned parking spaces, additional storage units, and flexible lease options. Situated in the vibrant Sand Lake neighborhood, our community offers the ideal blend of convenience and serenity, making it a welcoming home for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in 99502",
      "seo_description": "Discover pet-friendly apartments in the 99502 area at Strawberry Lane. Spacious layouts and convenient pet amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "flexible-lease-terms-apartments-anchorage-ak",
      "search_query": "flexible lease terms apartments Anchorage AK",
      "category": "Amenity",
      "h1_title": "Flexible Lease Apartments in Anchorage, AK",
      "h2_subtitle": "Explore apartments with flexible lease terms in Anchorage, AK. Strawberry Lane adapts to suit your lifestyle needs.",
      "page_copy": "Searching for apartments with flexible lease terms in Anchorage, AK? Look no further than Strawberry Lane. Located in the welcoming Sand Lake area, our community understands the need for adaptable living arrangements. Whether you're in town temporarily or looking for a long-term residence, our various lease options cater to your unique situation.\n\nBeyond flexibility, our residents enjoy modern comforts such as private patios or balconies, pet-friendly facilities, and additional storage spaces. With free assigned parking and a convenient location in the Anchorage Municipality, Strawberry Lane combines comfort and convenience to enhance your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Lease Apartments in Anchorage, AK",
      "seo_description": "Find apartments with flexible lease terms in Anchorage, AK at Strawberry Lane. Comfort and convenience designed for your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-sand-lake-anchorage",
      "search_query": "two bedroom apartments sand lake anchorage",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sand Lake, Anchorage",
      "h2_subtitle": "Discover spacious two bedroom apartments in the Sand Lake neighborhood of Anchorage. Enjoy the vibrant and serene lifestyle at Strawberry Lane.",
      "page_copy": "If you're looking for two bedroom apartments in Sand Lake, Anchorage, Strawberry Lane offers the perfect mix of space and amenities. Nestled in the tranquil Anchorage Municipality, our two bedroom units are designed to provide ample living space and comfort. Each apartment includes a private patio or balcony, allowing residents to enjoy the beautiful Alaskan scenery from the comfort of home.\n\nIn addition to generous living spaces, residents can take advantage of our community features like pet-friendly stations, assigned parking spaces without extra costs, and flexible lease terms. Come experience a balanced lifestyle of convenience and relaxation in our Sand Lake neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Sand Lake, Anchorage",
      "seo_description": "Explore spacious two bedroom apartments in Sand Lake, Anchorage at Strawberry Lane. Experience modern living in a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-alaska-anchorage-sand-lake",
      "search_query": "apartments near university of alaska anchorage sand lake",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Find ideal apartments near the University of Alaska, Anchorage. Located in Sand Lake, Strawberry Lane offers convenience and modern living.",
      "page_copy": "Looking for apartments near the University of Alaska Anchorage? Strawberry Lane in the Sand Lake neighborhood provides an ideal location just a short drive from campus. Our community offers modern amenities and a tranquil environment, perfect for students and faculty members alike.\n\nStrawberry Lane boasts free assigned parking, flexible lease terms, and spacious accommodations with private patios or balconies, making it a perfect choice for those seeking comfort and convenience. Residents also enjoy access to additional storage units and pet-friendly facilities, all within the charming surroundings of Anchorage's Sand Lake community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Discover apartments near the University of Alaska, Anchorage at Strawberry Lane in Sand Lake. Perfect for students and staff seeking a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center-anchorage-ak",
      "search_query": "apartments near Alaska Native Medical Center Anchorage AK",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Explore top apartments near the Alaska Native Medical Center in Anchorage, AK. Strawberry Lane offers convenience and superior living.",
      "page_copy": "For those seeking apartments near the Alaska Native Medical Center in Anchorage, AK, Strawberry Lane offers a prime location combined with exceptional amenities. Situated in the peaceful Sand Lake neighborhood, our community provides a serene escape just a short drive from the Medical Center, making it ideal for healthcare professionals and patients alike.\n\nResidents at Strawberry Lane enjoy the benefits of modern living with features such as private patios or balconies, free assigned parking, and flexible lease terms. Our pet-friendly environment and additional storage facilities further enhance the living experience, ensuring comfort and convenience in the heart of Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Find convenient apartments near the Alaska Native Medical Center in Anchorage, AK at Strawberry Lane. Ideal for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-alaska-medical-center-sand-lake",
      "search_query": "apartments close to Providence Alaska Medical Center Sand Lake",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence Medical Center",
      "h2_subtitle": "Discover apartments close to Providence Alaska Medical Center, located in Sand Lake. Enjoy modern comforts at Strawberry Lane in Anchorage.",
      "page_copy": "Searching for apartments close to Providence Alaska Medical Center in Sand Lake? Strawberry Lane provides a convenient location with modern amenities that make life easier. Situated within Anchorage, our community ensures quick access to the Medical Center, catering perfectly to healthcare employees and patients seeking nearby accommodations.\n\nOur residents benefit from amenities like private patios or balconies, ensuring you have a relaxing outlet at home. With additional perks such as free assigned parking and pet-friendly stations, Strawberry Lane suits both personal and professional needs. Experience the calm of Sand Lake paired with close access to essential destinations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Providence Medical Center",
      "seo_description": "Find modern apartments near Providence Alaska Medical Center in Sand Lake at Strawberry Lane. Perfect for healthcare professionals in Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-near-kincaid-park-anchorage",
      "search_query": "apartments near Kincaid Park Anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Kincaid Park, Anchorage",
      "h2_subtitle": "Explore apartments near Kincaid Park in Anchorage. Strawberry Lane in Sand Lake offers the perfect blend of nature and urban living.",
      "page_copy": "If you're looking for apartments near Kincaid Park in Anchorage, Strawberry Lane is a wonderful choice. Nestled in the serene Sand Lake neighborhood, our community provides quick and easy access to Kincaid Park. Whether you enjoy hiking, biking, or scenic picnics, this beautiful park is just minutes away, making it an ideal home base for outdoor enthusiasts.\n\nStrawberry Lane offers a range of amenities, including private patios or balconies, perfect for unwinding after a day at the park. We provide additional storage units for all your gear and equipment, and residents enjoy free assigned parking. Discover the perfect balance of nature and convenience at Strawberry Lane.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kincaid Park, Anchorage",
      "seo_description": "Find your ideal home at Strawberry Lane, located near Kincaid Park in the Sand Lake area of Anchorage. Experience nature with urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "rentals-close-to-earthquake-park-sand-lake",
      "search_query": "rentals close to Earthquake Park Sand Lake",
      "category": "Park",
      "h1_title": "Rentals Close to Earthquake Park",
      "h2_subtitle": "Find rentals close to Earthquake Park in the tranquil Sand Lake neighborhood. Enjoy modern living at Strawberry Lane.",
      "page_copy": "For those seeking rentals close to Earthquake Park in the Sand Lake area, Strawberry Lane is the perfect destination. Our community offers a peaceful retreat just a short distance from the intriguing natural landscapes of Earthquake Park, making it ideal for anyone who loves the outdoors.\n\nAt Strawberry Lane, residents benefit from a variety of modern amenities, including private patios or balconies that offer a great spot for relaxation. Additional storage units are available for your convenience, ensuring you have ample space for your outdoor gear. Experience the peace of Sand Lake with all the modern comforts at Strawberry Lane.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Earthquake Park, Sand Lake",
      "seo_description": "Discover rentals near Earthquake Park in Sand Lake at Strawberry Lane. Enjoy a tranquil setting with modern amenities in Anchorage, AK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-botanical-garden-anchorage",
      "search_query": "apartments near Alaska Botanical Garden Anchorage Municipality",
      "category": "Park",
      "h1_title": "Apartments Near Alaska Botanical Garden",
      "h2_subtitle": "Experience living near the Alaska Botanical Garden in Anchorage Municipality. Discover comfort at Strawberry Lane in Sand Lake.",
      "page_copy": "Located just a short drive from the enchanting Alaska Botanical Garden, Strawberry Lane offers apartments that blend convenience with natural beauty in Anchorage Municipality. Ideal for nature lovers, our community provides quick access to the garden's diverse plant collections and picturesque trails, perfect for leisurely strolls and nature appreciation.\n\nStrawberry Lane isn't just about proximity to nature; it's about quality living. Residents enjoy private patios or balconies, providing peaceful outdoor spaces to complement visits to the Botanical Garden. With flexible lease terms and pet-friendly amenities, Strawberry Lane is designed to fit the lifestyle of those who appreciate both modern comfort and natural beauty.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Botanical Garden",
      "seo_description": "Live near Alaska Botanical Garden at Strawberry Lane. Enjoy the beauty of Anchorage Municipality with modern amenities in Sand Lake.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167261",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-anchorage-airport",
      "search_query": "apartments near ted stevens anchorage airport",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens Airport",
      "h2_subtitle": "Discover convenient living near Ted Stevens Anchorage Airport. Enjoy the comfort of Strawberry Lane in Sand Lake.",
      "page_copy": "Strawberry Lane offers the perfect option for those searching for apartments near Ted Stevens Anchorage Airport. Our community is strategically located in the serene Sand Lake area, providing the convenience of being just a short drive away from the airport. This is ideal for frequent flyers or those working in aviation.\n\nIn addition to its prime location, Strawberry Lane boasts a variety of amenities, such as private patios or balconies, flexible lease terms, and free assigned parking spaces. The pet stations and additional storage units make it a great choice for those who value both convenience and comfort. Make Strawberry Lane your home base for easy airport access and exceptional living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens Airport",
      "seo_description": "Find your home at Strawberry Lane, near Ted Stevens Anchorage Airport. Enjoy easy access and modern amenities in Sand Lake, AK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309854897"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085523"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NTWHF89P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "c41f9599-971a-4358-a140-190e5a61fe37"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/16a7a4c5-33ee-4044-8fac-ec8da9e91ade/app.js?property=16a7a4c5-33ee-4044-8fac-ec8da9e91ade&propertyName=Strawberry+Lane&channelUuid=c2490157-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47606453394"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImVCcXNBb0tWZC9Fd2pBQ3JhRkozeGc9PSIsInZhbHVlIjoiajRwaGVmZzhHRk8yRFltYVVPNFRFZz09IiwibWFjIjoiYTFiYjc3ZjYxZDQ4MWFlOWU5MjBlMDJhZTg4ZjJkNTIxMzc0NDMzZDlhODI2Y2FkZDUzYzNkNjgxODBiZGI2MSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309854897",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085523",
  "custom_google_gtm_id": "GTM-NTWHF89P",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "c41f9599-971a-4358-a140-190e5a61fe37",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/16a7a4c5-33ee-4044-8fac-ec8da9e91ade/app.js?property=16a7a4c5-33ee-4044-8fac-ec8da9e91ade&propertyName=Strawberry+Lane&channelUuid=c2490157-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47606453394",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImVCcXNBb0tWZC9Fd2pBQ3JhRkozeGc9PSIsInZhbHVlIjoiajRwaGVmZzhHRk8yRFltYVVPNFRFZz09IiwibWFjIjoiYTFiYjc3ZjYxZDQ4MWFlOWU5MjBlMDJhZTg4ZjJkNTIxMzc0NDMzZDlhODI2Y2FkZDUzYzNkNjgxODBiZGI2MSJ9",
  "custom_audioeye_site_id": "427a3045-5bec-4491-a271-7f844b73db15",
  "custom_audioeye_site_hash": "6f212298b3083a9d5665dcfad29969bb"
};

export const generatedAt = '2026-10-27T16:59:49.705Z';
